module.exports = __webpack_public_path__ + "img/icon9.3493d70b.png";